"use client";
import React, { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Video from "yet-another-react-lightbox/plugins/video";
// import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import { Slide } from "yet-another-react-lightbox";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import { Camera, ImageIcon } from "lucide-react";
import Image from "components/common/Image";
import { get, isEmpty } from "utils/lodash";
import helper from "utils/helper";

const SpaGallery = ({
  data,
}: {
  data: { url: string; alt: string; width: number; height: number }[];
}) => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  if (isEmpty(data)) return null;

  const galleryImages = data?.slice(0, 5) || [];
  const openLightbox = (index: number) => {
    setCurrentIndex(index);
    setLightboxOpen(true);
  };

  const mainImage = galleryImages[0];
  const thumbnailImages = galleryImages.slice(1);

  // Prepare images for lightbox
  const lightboxSlides: Slide[] = data?.map(
    (img: { url: string; alt: string; width: number; height: number }) => ({
      src: helper.imageUrl(img.url),
      alt: img.alt,
      width: img.width,
      height: img.height,
      type: "image",
    })
  );
  return (
    <div className="container mx-auto p-4 ">
      {/* Header */}
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 bg-primary rounded flex items-center justify-center">
            <ImageIcon className="w-5 h-5 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-gray-800">Hình ảnh</h1>
        </div>
        <p className="text-gray-600">{galleryImages.length} ảnh, 0 video</p>
      </div>

      {/* Gallery Layout */}
      <div className="grid sm:grid-cols-2 2xl:grid-cols-3 grid-cols-1 gap-4 ">
        {/* Main Image - Takes 2 columns on large screens */}
        <div
          className="sm:col-span-1 2xl:col-span-2 md:col-span-1 relative group cursor-pointer overflow-hidden rounded-xl shadow-lg aspect-square sm:aspect-auto"
          onClick={() => openLightbox(0)}
        >
          <Image
            src={mainImage.url}
            alt={mainImage.alt}
            wrapClassName="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
            layout="fill"
            objectFit="cover"
          />
          <div className="absolute inset-0 bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 flex items-center justify-center">
            <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <Camera className="w-12 h-12 text-white" />
            </div>
          </div>
        </div>

        {/* Thumbnail Grid - Takes 1 column on large screens */}

        <div className="grid grid-cols-2 gap-3">
          {thumbnailImages.map(
            (image: { url: string; alt: string }, index: number) => (
              <div
                key={index}
                className="relative group cursor-pointer overflow-hidden rounded-lg shadow-md aspect-square"
                onClick={() => openLightbox(index + 1)}
              >
                <Image
                  src={image.url}
                  alt={image.alt}
                  wrapClassName="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                  layout="fill"
                  objectFit="cover"
                />
                <div className="absolute inset-0 bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-300 flex items-center justify-center">
                  <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <Camera className="w-8 h-8 text-white" />
                  </div>
                </div>
              </div>
            )
          )}
        </div>
      </div>

      {/* Lightbox */}
      <Lightbox
        open={lightboxOpen}
        close={() => setLightboxOpen(false)}
        index={currentIndex}
        slides={lightboxSlides}
        plugins={[Thumbnails, Video, Fullscreen]}
        carousel={{
          finite: false,
          preload: 2,
        }}
        render={{
          slide: ({ slide }: { slide: unknown }) => {
            return (
              <Image
                src={get(slide, "src", "")}
                alt={get(slide, "alt", "")}
                wrapClassName="w-full h-full"
                objectFit="contain"
              />
            );
          },
        }}
        styles={{
          container: { backgroundColor: "rgba(0, 0, 0, 0.9)" },
        }}
      />
    </div>
  );
};

export default SpaGallery;
